export default (function ($) {
    var _instance = {}
    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {

            var filter = $('.filter__dropdown');

            if (filter.length > 0) {
                function closeFilter($this) {
                    $this.find('.filter__list').slideUp(300, function () {
                        $this.closest(".toolbar__group").height("auto");
                    });
                    $this.find(".filter__button").removeClass('shown');
                }

                function openFilter($this) {
                    $this.find(".filter__button").addClass('shown');
                    $this.find('.filter__list').slideDown(300, function () {
                        var height = $this.find(".filter__list").outerHeight() + $this.outerHeight();
                        $this.closest(".toolbar__group").height(height);
                    });
                }

                function filtering() {
                    filter.on('click', function (e) {
                        if (!$(e.target).is("a") || $(e.target).is(".filter__button")) {
                            e.preventDefault();
                        }

                        if (!$(this).find(".filter__button").hasClass('shown')) {
                            openFilter($(this));
                        }
                    })
                }

                filtering();

                $('html').on('click', function (e) {
                    if ($(e.target).closest('.filter__dropdown').length === 0) {
                        closeFilter($(this));
                    }
                });
            }

        });
    };

    return _instance;

})(jQuery)
